//region :: Imports ::
import React, {ReactElement} from 'react';
import {withMsal, WithMsalProps} from '@azure/msal-react';
import MComponent from '../../Toolkit/Components/Component';
import WithRouterProps from '../../Toolkit/WithRouterProps';
import withRouter from '../../Toolkit/WithRouter';
import {Navigate} from 'react-router-dom';

//endregion

/** */
type RouteParams = {
    id: string;
};

/** */
type Props = WithMsalProps & WithRouterProps<RouteParams> & {}

/** */
type State = {
}

/** */
class NaviHome extends MComponent<Props, State> {
    /** */
    public constructor(props: Props) {
        super(props);

    }

    /** */
    public render(): ReactElement {
        //Use the currently logged in user roles to set default homepage.
        //const userName = this.props.msalContext.accounts[0].name;
        const roles = this.props.msalContext.accounts[0].idTokenClaims!.roles;
        const planningMember = roles?.includes('Planner') === true;

        return (
            planningMember ? <Navigate to={'/requests'}/> : <Navigate to={'/bookings'}/>
        );
    }
}

export default withMsal(withRouter(NaviHome));